module.exports = __webpack_public_path__ + "static/media/renewal.e651311d.svg";